import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import { projectsData } from "../data/projectsData";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

export default function ProjectDetails() {

  const { id } = useParams();
  const project = projectsData.find((p) => p.id === id);

  const [activeLayout, setActiveLayout] = useState(
    project.layouts ? project.layouts[0] : null
  );

  if (!project) return <div>Project not found</div>;

  return (
    <section className="bg-[#FDFBF7]">

      {/* HERO IMAGE */}

      <div className="relative h-[70vh] overflow-hidden">

        <img
          src={project.images[0]}
          alt={project.title}
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/40"></div>

        <div className="absolute bottom-10 left-10 text-white">

          <Link
            to="/portfolio"
            className="flex items-center gap-2 text-white/80 mb-4 hover:text-[#C9A962]"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Projects
          </Link>

          <h1 className="text-4xl md:text-5xl font-serif">
            {project.title}
          </h1>

          <p className="text-white/80 mt-2">
            {project.location}
          </p>

        </div>

      </div>


      <div className="max-w-7xl mx-auto px-6 md:px-16 py-20">

        {/* PROJECT INFO */}

        <div className="grid md:grid-cols-4 gap-8 mb-16">

          <div>
            <h4 className="text-sm text-[#2C2C2C]/60">Location</h4>
            <p className="font-serif text-lg">{project.location}</p>
          </div>

          <div>
            <h4 className="text-sm text-[#2C2C2C]/60">Category</h4>
            <p className="font-serif text-lg">{project.category}</p>
          </div>

          <div>
            <h4 className="text-sm text-[#2C2C2C]/60">Area</h4>
            <p className="font-serif text-lg">2400 sq ft</p>
          </div>

          <div>
            <h4 className="text-sm text-[#2C2C2C]/60">Completion</h4>
            <p className="font-serif text-lg">2024</p>
          </div>

        </div>


        {/* DESCRIPTION */}

        <div className="max-w-3xl mb-20">

          <h2 className="text-3xl font-serif mb-4">
            Project Overview
          </h2>

          <p className="text-[#2C2C2C]/70 leading-relaxed">
            {project.description}
          </p>

        </div>


        {/* IMAGE GALLERY */}

        <div className="grid md:grid-cols-2 gap-6 mb-24">

          {project.images.map((img, index) => (

            <img
              key={index}
              src={img}
              alt=""
              className="w-full object-cover rounded hover:scale-[1.02] transition"
            />

          ))}

        </div>


        {/* 2D LAYOUT SECTION */}

        {project.layouts && (

          <div>

            <div className="text-center mb-12">

              <h2 className="text-4xl font-serif text-[#2C2C2C] mb-4">
                2D Layout Plans
              </h2>

              <p className="text-[#2C2C2C]/60">
                Explore architectural floor plans of this project
              </p>

            </div>


            {/* Layout Filters */}

            <div className="flex justify-center gap-4 mb-10">

              {project.layouts.map((layout, index) => (

                <button
                  key={index}
                  onClick={() => setActiveLayout(layout)}
                  className={`px-6 py-2 border text-sm transition
                    ${
                      activeLayout.name === layout.name
                        ? "bg-[#C9A962] text-white border-[#C9A962]"
                        : "border-gray-300 text-[#2C2C2C]"
                    }
                  `}
                >
                  {layout.type}

                </button>

              ))}

            </div>


            {/* PDF VIEWER */}

            <div className="bg-white border p-6 shadow-sm">

              <iframe
                src={activeLayout.pdf}
                title="Layout"
                className="w-full h-[600px]"
              ></iframe>

              <div className="text-center mt-6">

                <a
                  href={activeLayout.pdf}
                  download
                  className="inline-flex items-center bg-[#C9A962] text-white px-8 py-3 hover:bg-[#b8954f]"
                >
                  Download Layout
                  <ArrowUpRight className="ml-2 w-4 h-4"/>
                </a>

              </div>

            </div>

          </div>

        )}

      </div>

    </section>
  );
}